import { max, mean, median, min, sum } from '@visx/vendor/d3-array';
import { first, flow, last } from 'lodash';

type SummaryFn = (arr: any[], accessor: (datum?: any) => number) => number | undefined;

const aggregators = {
    sum: sum,
    avg: mean,
    median: median,
    min: min,
    max: max,
    first: <T>(arr: T[], accessor: (datum?: T) => number) => flow(first, accessor)(arr),
    last: <T>(arr: T[], accessor: (datum?: T) => number) => flow(last, accessor)(arr),
} as Record<'sum' | 'avg' | 'min' | 'max' | 'first' | 'last', SummaryFn>;

const aggregatorOptions = Object.keys(aggregators).map(key => ({ label: key.toUpperCase(), value: key }));

export type { SummaryFn };
export { aggregatorOptions, aggregators };
